import { movieCatalog } from '@/mocks/movies';
import type { Movie } from '@/pages/home/types';
import MovieCard from '@/pages/home/components/MovieCard';
import SectionHeading from '@/pages/home/components/SectionHeading';

interface FreeSectionProps {
  onPickGenre: (genre: string) => void;
}

export default function FreeSection({ onPickGenre }: FreeSectionProps) {
  const freeMovies = (movieCatalog as Movie[]).filter((m) => m.free);

  return (
    <section id="free" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="免费专区"
            title="555电影免费电影专区"
            desc="把片库中标注为免费的内容单独聚合，省去逐个翻找的时间。免费片单覆盖剧情、爱情、冒险、动画等类型，适合想先从轻松内容入手的用户。"
          />
          <div className="flex items-center gap-2 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3 text-sm text-accent-700">
            <i className="ri-gift-line text-xl"></i>
            <span>当前专区共收录 <strong>{freeMovies.length}</strong> 部免费内容</span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {freeMovies.map((m) => (
            <MovieCard key={m.id} movie={m} onOpenGenre={onPickGenre} />
          ))}
        </div>
      </div>
    </section>
  );
}